import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.wholeHouse.recipeCopy.sortFields,
	columnFields: constants.wholeHouse.recipeCopy.columnFields,
	standardFilterFields: constants.wholeHouse.recipeCopy.standardFilterFields,
	dateFilterFields: constants.wholeHouse.recipeCopy.dateFilterFields,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
